// Mapeamento dos avatares disponíveis no sistema
import SpideyImg from "assets/img/Spidey.png";
import SteveImg from "assets/img/Steve.png";
import SuperguyImg from "assets/img/Superguy.png";
import TonyImg from "assets/img/Tony.png";
import WandaImg from "assets/img/Wanda.png";
import WolvyImg from "assets/img/Wolvy.png";

export const AVATAR_MAP: { [key: string]: string } = {
  Spidey: SpideyImg,
  Steve: SteveImg,
  Superguy: SuperguyImg,
  Tony: TonyImg,
  Wanda: WandaImg,
  Wolvy: WolvyImg,
};

export const AVATARS = [
  { name: "Spidey", image: SpideyImg },
  { name: "Steve", image: SteveImg },
  { name: "Superguy", image: SuperguyImg },
  { name: "Tony", image: TonyImg },
  { name: "Wanda", image: WandaImg },
  { name: "Wolvy", image: WolvyImg },
];

/**
 * Retorna a URL da imagem do avatar baseado no nome ou caminho
 * @param avatarName - Nome do avatar (ex: "Spidey"), URL completa ou base64
 * @returns URL da imagem do avatar
 */
export function getAvatarImage(avatarName?: string): string | undefined {
  if (!avatarName) return undefined;

  // Se já for uma URL completa, caminho ou base64, retorna direto
  if (
    avatarName.startsWith("http") ||
    avatarName.startsWith("/") ||
    avatarName.startsWith("data:") || // ✅ Suporte para base64
    avatarName.includes(".png") ||
    avatarName.includes(".jpg") ||
    avatarName.includes(".jpeg") ||
    avatarName.includes(".webp")
  ) {
    return avatarName;
  }

  // Busca no mapeamento
  return AVATAR_MAP[avatarName];
}
